var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15289 0.151367H18.8471C19.76 0.151367 20.5 1.00619 20.5 2.06066V8.74336H18.682V6.83405H2.31836V13.5162H10.5V15.4257H2.15289C1.24003 15.4257 0.5 14.5709 0.5 13.5164V2.06066C0.5 1.00619 1.24003 0.151367 2.15289 0.151367ZM18.682 2.06041V4.92476H2.31836V2.06041H18.682ZM19.9688 13.5164H15.7999L16.9752 14.7507L15.6896 16.1007L12.3195 12.5618L15.6896 9.02278L16.9752 10.3729L15.7999 11.6071H19.9688V13.5164Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.d214a995b50350d3a86fa61ee19eccbc.svg";
export { ForwardRef as ReactComponent };